
<div class="container">
  <mat-accordion class="example-headers-align">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="title">Tipo Respuesta</mat-panel-title>
      </mat-expansion-panel-header>

      <data-table
        title
        [columns]="columnasTipoRespuesta"
        [data]="dataTipoRespuesta"
        [configuration]="configurationTipoRespuesta"
        (add)="agregarTipoRespuesta($event)"
        (edit)="editarTipoRespuesta($event)"
        (delete)="eliminarTipoRespuesta($event)"
        [params]="paramsTipoRespuesta"
        [url]="urlGetDatosTipoRespuesta"
        [reloadTable]="recargarTablaTipoRespuesta"
      ></data-table>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="title">Respuestas</mat-panel-title>
      </mat-expansion-panel-header>

      <data-table
        title
        [columns]="columnasRespuestas"
        [data]="dataRespuestas"
        [configuration]="configurationRespuestas"
        (add)="agregarRespuestas($event)"
        (edit)="editarRespuestas($event)"
        (delete)="eliminarRespuestas($event)"
        [params]="paramsRespuestas"
        [url]="urlGetDatosRespuestas"
        [reloadTable]="recargarTablaRespuestas"
      ></data-table>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="title">EPS</mat-panel-title>
      </mat-expansion-panel-header>

      <data-table
        title
        [columns]="columnasEps"
        [configuration]="configurationEps"
        (add)="agregarEps($event)"
        (edit)="editarEps($event)"
        (delete)="eliminarEps($event)"
        [params]="paramsEps"
        [url]="urlGetDatosEps"
        [reloadTable]="recargarTablaEps"
      ></data-table>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="title">ARL</mat-panel-title>
      </mat-expansion-panel-header>

      <data-table
        title
        [columns]="columnasArl"
        [configuration]="configurationArl"
        (add)="agregarArl($event)"
        (edit)="editarArl($event)"
        (delete)="eliminarArl($event)"
        [params]="paramsArl"
        [url]="urlGetDatosArl"
        [reloadTable]="recargarTablaArl"
      ></data-table>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="title">Nueva version Generada</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="d-flex justify-content-center">
        <button
        style="    border-radius: 50%; height: 200px; width: 200px; background: blue;"
        (click)="handlerVersion()">
        <h1 style="color: white" class="m-0 p-0">launch version</h1>
        </button>

      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
